export default __webpack_public_path__ + "static/1-9b423b8b6a2b2d2a477ccb846f4044bf.png";